import { useState } from "react";

import { ListProps } from "../Globals";
import useGlobals from "../../../../api/api-hooks/globals/useGlobal";
import { Layout } from "../../../../types/GlobalInterfaces";
import { GlobalBody } from "./GlobalBody";
import CreateTableLayoutDrawer from "../../../../components/TableLayouts/CreateTableLayoutDrawer";

/**
 * Higher order component for managing Global Layouts
 */
export default function LayoutsList({
  createGlobal,
  isCreating,
  updateGlobal,
  updateID,
  deleteGlobal,
  deleteID,
}: ListProps) {
  const [createDrawerOpen, setCreateDrawerOpen] = useState(false);
  const { globals, globalsLoading } = useGlobals<Layout[]>("Layouts");
  const [editLayout, setEditLayout] = useState<Layout>();
  const [selectedLayoutType, setLayoutType] = useState<string | null>(null);

  return (
    <>
      <GlobalBody
        type="Layouts"
        items={globals}
        onEditGlobal={setEditLayout}
        updateID={updateID}
        loadingItems={globalsLoading}
        deleteID={deleteID}
        updateGlobal={updateGlobal}
        handleDelete={deleteGlobal}
        setCreateDrawerOpen={() => setCreateDrawerOpen(true)}
        selectedLayoutType={selectedLayoutType}
        setLayoutType={setLayoutType}
      />
      {/* @ts-ignore */}
      <CreateTableLayoutDrawer
        open={createDrawerOpen || !!editLayout}
        submitting={isCreating || !!updateID}
        onClose={() => {
          setCreateDrawerOpen(false);
          setEditLayout(undefined);
        }}
        useModulePicker={true}
        useTypeSelect={true}
        handleCreate={createGlobal}
        handleUpdate={updateGlobal}
        title={"Global"}
        existingLayout={editLayout}
        usePageSelection={false}
      />
    </>
  );
}
